import { ArcStack } from "@src/core/ui";
import React, { useEffect } from "react";
import { ZoneItem } from '@src/features/zones/pages/zones-page/components/ZoneItem';
import { ZoneListProps } from '@src/features/zones/pages/zones-page/types';
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedZone, setHoveredSafeLandZoneId, setSelectedZone } from "@src/features/zones/redux";
import { setHoveredNoFlyZoneId } from '@src/core/features/zones/redux';

export const ZoneList: React.FC<ZoneListProps> = (props ) => {
  const { zones, variant } = props;
  const selectedZone = useSelector(selectSelectedZone);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(setSelectedZone(null));
      dispatch(setHoveredSafeLandZoneId(null));
      dispatch(setHoveredNoFlyZoneId(null));
    };
  }, [dispatch]);
    
  return (
    <ArcStack spacing={1} marginTop={2} marginBottom={1.2}>
      {zones.map((zone) => {
        const isSelected = selectedZone?.id === zone.id;
        return (
          <ZoneItem   variant={variant}
            key={zone.id} 
            zone={zone} 
            isSelected={isSelected}
          />
        );
      })}
    </ArcStack>
  );
};